"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _edSystem = require("@eduact/ed-system");
var _Skeletons = require("../../Skeletons");
var _react = _interopRequireDefault(require("react"));
var _BaseWidget = require("./BaseWidget.styled");
var _BaseWidget2 = require("./BaseWidget.types");
var _WidgetProvider = require("./WidgetProvider");
var _excluded = ["bg", "withShadow", "widget", "onClick", "contained", "widgetProps", "withLoading", "isLoading"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var BaseWidget = function BaseWidget(props) {
  return /*#__PURE__*/_react["default"].createElement(_WidgetProvider.WidgetProvider, null, /*#__PURE__*/_react["default"].createElement(WidgetUIContainer, props));
};
var WidgetUIContainer = function WidgetUIContainer(_ref) {
  var _ref$bg = _ref.bg,
    bg = _ref$bg === void 0 ? 'light' : _ref$bg,
    _ref$withShadow = _ref.withShadow,
    withShadow = _ref$withShadow === void 0 ? false : _ref$withShadow,
    widget = _ref.widget,
    onClick = _ref.onClick,
    contained = _ref.contained,
    widgetProps = _ref.widgetProps,
    withLoading = _ref.withLoading,
    isLoading = _ref.isLoading,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useWidget = (0, _WidgetProvider.useWidget)(),
    title = _useWidget.title,
    action = _useWidget.action;
  return /*#__PURE__*/_react["default"].createElement(_BaseWidget.BaseWidgetContainer, _extends({
    contained: contained,
    bg: bg,
    withShadow: withShadow
  }, props), /*#__PURE__*/_react["default"].createElement(_Skeletons.SkeletonBox, {
    width: '100%',
    height: '100%',
    isLoading: !!isLoading && !!withLoading
  }, /*#__PURE__*/_react["default"].createElement(_BaseWidget.BaseWidgetSpaceContainer, {
    contained: contained
  }, !contained && /*#__PURE__*/_react["default"].createElement(_BaseWidget.BaseWidgetHeader, {
    width: '100%',
    justifyContent: 'space-between',
    alignItems: 'center'
  }, title && /*#__PURE__*/_react["default"].createElement(_BaseWidget.BaseWidgetTitle, null, title), action), /*#__PURE__*/_react["default"].createElement(_edSystem.Box, {
    height: 'inherit',
    minHeight: 'inherit',
    width: '100%'
  }, widget && (0, _BaseWidget2.isReactComponent)(widget) && widget(widgetProps)))));
};
var _default = BaseWidget;
exports["default"] = _default;